import { render, staticRenderFns } from "./OrdersFBMCreation.vue?vue&type=template&id=af946c0a&scoped=true"
import script from "./OrdersFBMCreation.vue?vue&type=script&lang=js"
export * from "./OrdersFBMCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af946c0a",
  null
  
)

export default component.exports